<template>
  <div :style="$style.container">
    <slot v-if="!loading" />

    <div v-show="loading" :class="$style.loader">
      <div
        v-for="(row, idx) in rows"
        :key="idx"
        :class="$style.row"
        :style="getAnimationDelayVariables()"
      >
        <div :class="$style.skeleton" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlatListSkeletonLoader',
  props: {
    loading: Boolean,
  },
  data() {
    return {
      rows: 5,
    };
  },
  methods: {
    getAnimationDelayVariables() {
      return {
        '--animation-cycle': `${Math.random() * 0.8}s`,
        '--animation-delay': `${Math.random() * 0.5}s`,
      };
    },
  },
};
</script>

<style lang="sass" module>
  .loader
    position: relative

  .row

    &:not(:last-child)
      margin-bottom: 10px

  .skeleton
    +size(100%, 64px)
    min-height: 64px
    background-color: #fff
    border-radius: 5px
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.15)
    animation: fade calc(var(--animation-cycle) + 1.2s) linear var(--animation-delay) infinite
    opacity: 0.05
    cursor: wait

  @keyframes fade
    0%
      opacity: 0.05
    50%
      opacity: .2
    100%
      opacity: 0.05
</style>
